module.exports = __webpack_public_path__ + "img/astral-txt_10.9af034d4.svg";